var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg12TriangleOdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10 -10 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 100 100, 0 100",
    strokeWidth: 8,
    stroke: "#000",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12TriangleOdd);
export default __webpack_public_path__ + "static/media/12-triangle-odd.6519cdb698b4f916c68755ea8092d65f.svg";
export { ForwardRef as ReactComponent };